import { toast } from 'react-toastify';
import { useSelector, useDispatch } from 'react-redux';
import { markAllJobFeedbacksRead } from '../../store/knownDataSlice';
import { DataContainer } from '../../components/DataContainer';



function JobFeedbackView({ id }) {
    const dispatch = useDispatch();
    const data = useSelector((state) => state.knownData[id]);
    const user = useSelector((state) => state.user.data);

    // Parse feedbacks data safely
    const feedbacks = data["job_feedbacks"] ? JSON.parse(data["job_feedbacks"]) : [];
    const hasUnreadFeedbacks = feedbacks.some(feedback => !feedback.isRead);

    // Parse extra drivers
    const extraDrivers = data["job_extra_drivers"] ? JSON.parse(data["job_extra_drivers"]) : [];
    const extraDriverNames = data["extra_driver_names"] || [];

    // Collect all drivers with IDs and names
    const allDrivers = [
        { id: data["job_driver"], name: data["driver_firstname"] },
        ...extraDrivers.map((driverId, index) => ({
            id: driverId,
            name: extraDriverNames[index] || 'Unknown Driver'
        }))
    ];

    // Collect submitted driver IDs
    const submittedIds = new Set(feedbacks.map(feedback => feedback.driver_id));

    // Find drivers without feedback
    const missingDrivers = allDrivers.filter(driver => !submittedIds.has(driver.id));

    async function onMarkAllRead() {
        await dispatch(markAllJobFeedbacksRead({ id }));
        toast.success("Kõik tagasisided märgitud loetuks!");
    }

    return (
        <>
            <hr />

                <DataContainer actionType={"knownData/markAllJobFeedbacksRead"}>

                    <div className="column g32">
                        <h2>Sõidu tagasiside juhtidelt</h2>

                        {data && !data["job_feedbacks"] ? (
                            <p style={{ color: '#888', textAlign: 'center' }}>Ükski juht pole veel tagasisidet andnud</p>
                        ) : (<>

                            {feedbacks.map((feedback, index) => {
                                const isPrimary = feedback.driver_id === data["job_driver_id"];
                                const driverName = isPrimary
                                    ? `${data["driver_firstname"]} (peajuht)`
                                    : `${feedback.driver_firstname}`;

                                return (
                                    <div key={feedback.feedback_id} className="column g16" style={{
                                        padding: '16px',
                                        border: '1px solid #ddd',
                                        borderRadius: '4px',
                                        backgroundColor: feedback.isRead ? '#f9f9f9' : '#fff'
                                    }}>
                                        <h3>{driverName}</h3>

                                        <div className="column g8">
                                            <div className="column g4">
                                                <b>Tulemus</b>
                                                <p>{feedback.wentWell ? "Positiivne" : "Negatiivne"}</p>
                                            </div>

                                            <div className="column g4">
                                                <b>Tunnid</b>
                                                <p>
                                                    {feedback.hours && Array.isArray(feedback.hours) ?
                                                        feedback.hours.map((h, i) => `${h} h (${i+1}. päev)`).join(', ') :
                                                        'Märkimata'
                                                    }
                                                </p>
                                            </div>

                                            <div className="column g4">
                                                <b>Tagasiside</b>
                                                <p>{feedback.comment || "-"}</p>
                                            </div>
                                        </div>

                                        {!feedback.isRead && (
                                            <div style={{ fontSize: '12px', color: '#666', fontStyle: 'italic' }}>
                                                Lugemata
                                            </div>
                                        )}
                                    </div>
                                );
                            })}

                            {missingDrivers.map((driver) => (
                                <div key={driver.id} className="column g16" style={{
                                    padding: '16px',
                                    border: '1px solid #ddd',
                                    borderRadius: '4px',
                                    backgroundColor: '#fff'
                                }}>
                                    <h3>{driver.name}</h3>
                                    <p>See juht pole esitanud tagasisidet</p>
                                </div>
                            ))}

                            { user.role === "admin" && hasUnreadFeedbacks && (
                                <button onClick={onMarkAllRead}>Liiguta arhiivi</button>
                            )}

                            { user.role === "admin" && !hasUnreadFeedbacks && (
                                <b className='w100 p8' style={{ textAlign: 'center', border: '1px solid #ddd' }}>
                                    Tellimus liigutatud arhiivi
                                </b>
                            )}

                    </>)}
                </div>
            </DataContainer>

        </>
    );
}

export default JobFeedbackView;